import { render, staticRenderFns } from "./vue-webrtc.vue?vue&type=template&id=011c5340"
import script from "./vue-webrtc.vue?vue&type=script&lang=js"
export * from "./vue-webrtc.vue?vue&type=script&lang=js"
import style0 from "./vue-webrtc.vue?vue&type=style&index=0&id=011c5340&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports